import { useEffect, useRef } from 'react'

import { IconSwitch2 } from '@tabler/icons-react'

import { CommandAction, CommandModule, DynamicActionsProps } from './config'

import {
  ProjectIcon,
  getProjectColour,
} from '@/components/shared-components/ProjectIcon'
import { useGroupedProjects, useProject } from '@/context/projectContext'
import { convertEnumToString, routes } from '@/utils/index'

import { ProjectStatus } from 'types/api.graphql'

export const DynamicProjectActions: React.FC<DynamicActionsProps> = ({
  addSubItemsToParent,
}) => {
  const setProjects = useRef(false)

  const { updateProject } = useProject()

  const [groupedProjects] = useGroupedProjects(false)

  useEffect(() => {
    if (setProjects.current) return

    setProjects.current = true

    addSubItemsToParent(CommandModule.Projects, [
      {
        id: 'goToProjectList',
        name: 'Directory',
        href: routes.projects.list(),
      },
      ...Object.keys(groupedProjects ?? {}).map((status) => ({
        id: status,
        groupTitle: convertEnumToString(status),
        groupActions: groupedProjects[status as ProjectStatus].map(
          (project) => ({
            id: project.id,
            name: project.name,
            icon: <ProjectIcon colour={getProjectColour(project)} size={22} />,
            subActions: [
              {
                id: 'viewProject',
                name: 'View Project',
                href: routes.projects.view(project.id),
              },
              {
                id: 'editProject',
                name: 'Edit Project',
                href: routes.projects.edit(project.id),
              },
              {
                id: 'setProject',
                name: 'Switch to Project',
                icon: IconSwitch2,
                perform: () => updateProject(project),
              },
            ] as CommandAction[],
          })
        ),
      })),
    ])
  }, [addSubItemsToParent, groupedProjects, updateProject])

  return null
}
